import { HAS_DISMISSED_EXPIRING_API_KEY_BANNER, useUserSpecificLocalStorage } from '../../../hooks/use-local-storage';
import { getHasDismissedBannerInThePast24Hrs } from './helpers';

/**
 * Has the current user dismissed the `ApiKeysExpiringBanner` in the previous 24hrs (via window.localStorage)
 * @returns {boolean}
 */
export const useHasDismissedBanner = () => {
  const [lastDismissedDateTimeISO] = useUserSpecificLocalStorage(HAS_DISMISSED_EXPIRING_API_KEY_BANNER);
  const hasDismissedTheBannerInThePast24Hrs = getHasDismissedBannerInThePast24Hrs(lastDismissedDateTimeISO);
  return hasDismissedTheBannerInThePast24Hrs;
};
